export default __webpack_public_path__ + "static/media/Inter-UI-ExtraLight-BETA.62b78a53.woff2";